import React from 'react';
import Ourhistoryabout from '../components/Aboutus/Ourhistory';

const ourhistoryabout = () =>{
    return(
        <>
        <Ourhistoryabout />
        </>
    )
};

export default ourhistoryabout;